import { TextInput } from 'react-admin';
import TinyMCEInput from '../TinyMCEInput';
import ArrayForm from './ArrayForm';
import BoundedInput from './BoundedInput';

const ArrayTitleContent = ({ index, source, }: { source: string, index: number }) => {
    return (
        <ArrayForm source={source} grid={0} simpleFormIteratorProps={{
          sx: {
              '& .RaSimpleFormIterator-form': {
                  display: 'grid',
                  gap: '0px',
                  columnGap: '10px',
                  gridTemplateAreas: `
'title_en title_en title_tc title_tc title_sc title_sc'
'html_en html_en html_en html_en html_en html_en'
'html_tc html_tc html_tc html_tc html_tc html_tc'
'html_sc html_sc html_sc html_sc html_sc html_sc'
`
              }
          }
      }}>
            <BoundedInput source={`title_en`} input={<TextInput source="dummy" fullWidth helperText={false} sx={{ gridArea: 'title_en'}} />} />
            <BoundedInput source={`title_tc`} input={<TextInput source="dummy" fullWidth helperText={false} sx={{ gridArea: 'title_tc'}} />} />
            <BoundedInput source={`title_sc`} input={<TextInput source="dummy" fullWidth helperText={false} sx={{ gridArea: 'title_sc'}} />} />
            <BoundedInput source={`html_en`} label="Description EN" input={<TinyMCEInput source="dummy" fullWidth helperText={false} sx={{ gridArea: 'html_en'}} />}/>
            <BoundedInput source={`html_tc`} label="Description TC" input={<TinyMCEInput source="dummy" fullWidth helperText={false} sx={{ gridArea: 'html_tc'}} />}/>
            <BoundedInput source={`html_sc`} label="Description SC" input={<TinyMCEInput source="dummy" fullWidth helperText={false} sx={{ gridArea: 'html_sc'}} />}/>            
        </ArrayForm>
    )
}

export default ArrayTitleContent;